import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularIndeterminate from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";

const WesternVocalsMusicClasses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { courses } = useSelector((state) => state.courses);
  const { batches } = useSelector((state) => state.batches);

  const defaultProps = {
    options: courses?.filter((itm) => itm?.event_id == "2"),
    getOptionLabel: (option) => option.name,
  };

  useEffect(() => {
    dispatch(actions.coursesGetData());
    dispatch(actions.batchesGetData());
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      branch_id: values.branch_id,
      course_id: values.course_id,
      // batch_id: values.batch_id,
      // time_slot_id: values.time_slot_id,
      is_online_payment: values.is_online_payment,
      is_enquiry: values.is_enquiry,
    };
    dispatch(actions.postCourse(coursereg, setSubmitting));
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  //client_message: "",
                  //age: "",
                  branch_id: "",
                  course_id: "",
                  // batch_id: "",
                  //   time_slot_id: "",
                  is_enquiry: "1",
                  is_online_payment: "0",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                })}
              >
                {(formProps) => (
                  <Form className="mt-3">
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="clientname" className="label">
                          Enter Your Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientname"
                            id="clientname"
                            placeholder="Enter Your Name"
                            className={
                              "form-control" +
                              (formProps.errors.clientname &&
                              formProps.touched.clientname
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientname"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="clientemail" className="label">
                          Enter Your Email:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientemail"
                            id="clientemail"
                            placeholder="Enter Your Email"
                            className={
                              "form-control" +
                              (formProps.errors.clientemail &&
                              formProps.touched.clientemail
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientemail"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="clientphone" className="label">
                          Enter Your Mobile:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientphone"
                            id="clientphone"
                            placeholder="Enter Your Mobile"
                            className={
                              "form-control" +
                              (formProps.errors.clientphone &&
                              formProps.touched.clientphone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientphone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="branch_id" className="label">
                          Select Branch Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="branch_id"
                            id="branch_id"
                            className={
                              "form-control" +
                              (formProps.errors.branch_id &&
                              formProps.touched.branch_id
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value="">Select Branch</option>
                          </Field>
                          <ErrorMessage
                            name="branch_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="course_id" className="label">
                          Select Course Interested in
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="course_id"
                            id="course_id"
                            className={
                              "form-control" +
                              (formProps.errors.course_id &&
                              formProps.touched.course_id
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value="">
                              Select Course Interested in{" "}
                            </option>
                          </Field>
                          <ErrorMessage
                            name="course_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <div className="mt-3 mb-3 row">
                      <div className="col-12">
                        <Button
                          type="submit"
                          className="register-btn"
                          size="md"
                          block
                        >
                          {isPostLoading ? (
                            <CircularIndeterminate />
                          ) : (
                            "REGISTER"
                          )}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default WesternVocalsMusicClasses;
